/*
  GO Motorsports product page: gallery, variant selection, quantity, add-on upgrades, add to cart
  (main item and checked upgrades in one request), added-to-cart toast, sticky bar, zoom, share.
  Fires document event 'cart:updated' with the cart so the header badge (and the cart drawer) update.
*/
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '${{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return withCommas.split('.')[0];
      if (key === 'amount_with_comma_separator') return value.replace('.', ',');
      return withCommas;
    });
  }

  /* ---------- Gallery ---------- */
  function initGallery(gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    if (!track) return null;
    var slides = track.children;
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    var count = gallery.querySelector('[data-gallery-count]');
    var raf;

    function index() { return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1)); }
    function go(i, instant) {
      var n = slides.length;
      i = (i + n) % n;
      track.scrollTo({ left: i * track.clientWidth, behavior: instant || reduceMotion ? 'auto' : 'smooth' });
    }
    function sync() {
      var i = index();
      thumbs.forEach(function (t, j) {
        t.classList.toggle('is-active', j === i);
        if (j === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
      if (count) count.textContent = (i + 1) + ' / ' + slides.length;
      // Pause videos that scrolled out of view.
      Array.prototype.forEach.call(slides, function (s, j) {
        if (j !== i) s.querySelectorAll('video').forEach(function (v) { v.pause(); });
      });
    }
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(sync); }, { passive: true });
    var prev = gallery.querySelector('[data-gallery-prev]');
    var next = gallery.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { go(index() - 1); });
    if (next) next.addEventListener('click', function () { go(index() + 1); });
    thumbs.forEach(function (t, j) { t.addEventListener('click', function () { go(j); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(index() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(index() - 1); }
    });

    // Start on the selected variant's photo.
    var featured = track.querySelector('[data-featured]');
    if (featured) go(Array.prototype.indexOf.call(slides, featured), true);

    return {
      showMedia: function (mediaId) {
        if (!mediaId) return;
        var slide = track.querySelector('[data-media-id="' + mediaId + '"]');
        if (slide) go(Array.prototype.indexOf.call(slides, slide));
      }
    };
  }

  /* ---------- Lightbox ---------- */
  function initLightbox(scope) {
    var dialog = document.querySelector('[data-lightbox]');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    var img = dialog.querySelector('[data-lightbox-image]');
    scope.querySelectorAll('[data-gallery-zoom]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        img.src = btn.dataset.galleryZoom;
        img.alt = (btn.querySelector('img') || {}).alt || '';
        dialog.showModal();
      });
    });
    dialog.addEventListener('click', function () { dialog.close(); });
  }

  /* ---------- Toast ---------- */
  var toast;
  function showToast(item) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'toast';
      toast.setAttribute('role', 'status');
      document.body.appendChild(toast);
    }
    var image = item && item.image ? '<span class="toast__image"><img src="' + item.image + '" alt=""></span>' : '';
    var title = item ? item.product_title : '';
    toast.innerHTML = image +
      '<span class="toast__text"><strong>' + (window.goStrings && goStrings.added || 'Added to your cart') + '</strong>' + title + '</span>' +
      '<a class="button button--accent button--compact" href="' + root + 'cart">' + (window.goStrings && goStrings.viewCart || 'View Cart') + '</a>';
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { toast.classList.remove('is-visible'); }, 5000);
  }

  /* ---------- Product ---------- */
  function initProduct(section) {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    var format = section.dataset.moneyFormat;
    var gallery = initGallery(section.querySelector('[data-gallery]') || section);
    initLightbox(section);

    var form = section.querySelector('[data-product-form]');
    var idInput = section.querySelector('[data-variant-id]');
    var qty = section.querySelector('[data-qty]');
    var upgrades = section.querySelectorAll('[data-upgrade]');
    var addButtons = section.querySelectorAll('[data-add], [data-sticky-add]');
    var errorBox = section.querySelector('[data-form-error]');
    var jsonEl = section.querySelector('[data-product-json]');
    var data = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var current = null;
    var basePrice = null;

    if (data) {
      current = data.variants.find(function (v) { return String(v.id) === idInput.value; }) || data.variants[0];
    }
    var totalEl = section.querySelector('[data-total]');
    var showTotal = !!section.querySelector('.product-form__add [data-total]');
    if (current) basePrice = current.price;
    else if (totalEl) basePrice = Math.round(parseFloat(totalEl.textContent.replace(/[^0-9.]/g, '')) * 100) || 0;

    function selectedOptions() {
      var picks = [];
      section.querySelectorAll('[data-option]').forEach(function (el) {
        var i = Number(el.dataset.option);
        if (el.type === 'radio') { if (el.checked) picks[i] = el.value; }
        else picks[i] = el.value;
      });
      return picks;
    }

    function updateTotal() {
      if (basePrice === null) return;
      var each = basePrice;
      var count = 0;
      upgrades.forEach(function (u) { if (u.checked) { each += Number(u.dataset.price); count++; } });
      var total = formatMoney(each * Math.max(1, Number(qty && qty.value) || 1), format);
      document.querySelectorAll('[data-section-id="' + section.dataset.sectionId + '"] [data-total]').forEach(function (el) { el.textContent = total; });
    }

    function onVariantChange() {
      var picks = selectedOptions();
      var variant = data.variants.find(function (v) {
        return v.options.every(function (o, i) { return picks[i] === undefined || o === picks[i]; });
      });
      section.querySelectorAll('[data-option-label]').forEach(function (el) { el.textContent = picks[Number(el.dataset.optionLabel)] || ''; });
      addButtons.forEach(function (b) { b.disabled = !variant || !variant.available; });
      var label = section.querySelector('[data-add-label]');
      if (!variant) {
        if (label) label.textContent = (window.goStrings && goStrings.unavailable) || 'Unavailable';
        return;
      }
      current = variant;
      basePrice = variant.price;
      idInput.value = variant.id;

      var price = section.querySelector('[data-price] .price');
      if (price) {
        var onSale = variant.compare_at_price > variant.price;
        // Keep the Wholesale Pricing Discount app's data-wpd-* attributes, updated for the new variant.
        var oldCurrent = price.querySelector('.price__current');
        price.classList.toggle('price--sale', onSale);
        price.innerHTML = '<span class="price__current">' + formatMoney(variant.price, format) + '</span>' +
          (onSale ? '<s class="price__compare data-wpd-hide">' + formatMoney(variant.compare_at_price, format) + '</s>' : '');
        var newCurrent = price.querySelector('.price__current');
        if (oldCurrent) {
          Array.prototype.forEach.call(oldCurrent.attributes, function (attr) {
            if (attr.name.indexOf('data-wpd-') === 0) newCurrent.setAttribute(attr.name, attr.value);
          });
          if (newCurrent.hasAttribute('data-wpd-variant-id')) {
            newCurrent.setAttribute('data-wpd-variant-id', variant.id);
            newCurrent.setAttribute('data-wpd-variant-price', variant.price);
            newCurrent.setAttribute('data-wpd-variant-compare-at-price', variant.compare_at_price || '');
          }
        }
      }
      var save = section.querySelector('[data-save]');
      if (save) {
        var percent = variant.compare_at_price > variant.price
          ? Math.floor((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) : 0;
        save.hidden = percent === 0;
        save.textContent = (save.dataset.template || '').replace('[percent]', percent);
      }
      var stock = section.querySelector('[data-stock]');
      if (stock) {
        stock.textContent = variant.available ? (goStrings.inStock || 'In stock') : (goStrings.outOfStock || 'Out of stock');
        stock.classList.toggle('badge--solid', !variant.available);
      }
      var sku = section.querySelector('[data-sku]');
      if (sku) { sku.hidden = !variant.sku; sku.textContent = (goStrings.sku || 'SKU') + ' ' + (variant.sku || ''); }
      if (label) {
        label.innerHTML = variant.available
          ? (goStrings.addToCart || 'Add to Cart') + (showTotal ? ' · <span data-total></span>' : '')
          : (goStrings.outOfStock || 'Out of stock');
      }
      if (gallery) gallery.showMedia(variant.media_id);
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
      updateTotal();
    }

    if (data) section.addEventListener('change', function (e) { if (e.target.matches('[data-option]')) onVariantChange(); });
    if (qty) qty.addEventListener('change', updateTotal);
    if (qty) qty.addEventListener('input', updateTotal);
    upgrades.forEach(function (u) { u.addEventListener('change', updateTotal); });

    /* Add to cart */
    function setBusy(busy) {
      addButtons.forEach(function (b) {
        b.classList.toggle('is-loading', busy);
        if (busy) b.disabled = true;
        else b.disabled = current ? !current.available : false;
      });
    }
    function showError(message) {
      if (!errorBox) return;
      errorBox.textContent = message;
      errorBox.hidden = !message;
    }
    function add() {
      var quantity = Math.max(1, Number(qty && qty.value) || 1);
      var items = [{ id: Number(idInput.value), quantity: quantity }];
      upgrades.forEach(function (u) { if (u.checked) items.push({ id: Number(u.value), quantity: quantity }); });
      setBusy(true);
      showError('');
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Go-Source': 'product-form' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
          var added = res.body.items ? res.body.items[0] : res.body;
          return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
            document.dispatchEvent(new CustomEvent('cart:added', { detail: { cart: cart, items: res.body.items || [added] } }));
            if (!window.goCartDrawer) showToast(added);
          });
        })
        .catch(function (err) { showError(err.message); })
        .finally(function () { setBusy(false); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
    var stickyAdd = section.querySelector('[data-sticky-add]');
    if (stickyAdd) stickyAdd.addEventListener('click', add);

    /* Sticky bar: shows once the main Add to Cart button scrolls out of view. */
    var bar = section.querySelector('[data-sticky-bar]');
    var mainAdd = section.querySelector('[data-add]');
    if (bar && mainAdd && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var past = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', past);
        bar.setAttribute('aria-hidden', past ? 'false' : 'true');
        if (stickyAdd) stickyAdd.tabIndex = past ? 0 : -1;
      }).observe(mainAdd);
    }

    /* Share */
    var share = section.querySelector('[data-share]');
    if (share) share.addEventListener('click', function () {
      var data = { title: share.dataset.title, url: share.dataset.url };
      if (navigator.share) { navigator.share(data).catch(function () {}); return; }
      if (navigator.clipboard) navigator.clipboard.writeText(data.url).then(function () {
        var done = section.querySelector('[data-share-done]');
        if (done) { done.hidden = false; setTimeout(function () { done.hidden = true; }, 2500); }
      });
    });

    updateTotal();
  }

  /* ---------- Video sections: load the player on click ---------- */
  function initVideos(scope) {
    scope.querySelectorAll('[data-video-poster]').forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = 'true';
      btn.addEventListener('click', function () {
        var tpl = btn.parentElement.querySelector('template');
        if (!tpl) return;
        btn.replaceWith(tpl.content.cloneNode(true));
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    scope.querySelectorAll('[data-product]').forEach(initProduct);
    initVideos(scope);
  }

  window.goStrings = window.goStrings || {};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
